module.exports = __webpack_public_path__ + "848766e54609c004f4537016ca3c9ac6.pdf";